import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {api} from "../../api";

export const getVacations = createAsyncThunk(
  'vacations/recordsList',
  async (_, thunkAPI) => {
    try {
      const response = await api.request(
        {
          url: '/OSSTimeControl/RecordsList',
          method: 'GET',
          headers: {
            'X-TOKEN': localStorage.getItem('token')
          }
        }
      );
      let data = response.data.result || []
      if (response.status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data.error);
      }
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data.error);
    }
  }
);

export const vacationsSlice = createSlice({
  name: 'vacations',
  initialState: {
    recordsList: [],
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: '',
  },
  reducers: {
  },
  extraReducers: {
    [getVacations.fulfilled]: (state, { payload }) => {
      state.isFetching = false;
      state.isSuccess = true;
      state.recordsList = payload
      return state;
    },
    [getVacations.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload.message;
    },
    [getVacations.pending]: (state) => {
      state.isFetching = true;
    },
  },
});

export const vacationsSelector = (state) => state.vacations;
